// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rule';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.563 7.313V6.188m0 4.5V9.562m0 4.501v-1.126m10.125 4.501h1.124m-4.499 0h1.125m-4.5 0h1.124m-3.374 0a1.125 1.125 0 0 1-1.125-1.125M16.688.563h-12a.75.75 0 0 0-.75.75v12c0 .414.335.75.75.75h12a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75z'
  />
);

export const viewBox = '0 0 18 18';
